import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "jquery-ui-bundle";
import "jquery-ui-bundle/jquery-ui.min.css";
import PatientDebitStatus from "../components/PatientDebitStatus";

const DATEPICKER_OPTIONS = {
    dateFormat: "mm/dd/yy",
    showButtonPanel: true,
    changeMonth: true,
    changeYear: true,
    yearRange: "1920:+nn",
    showOtherMonths: true,
    selectOtherMonths: true,
};

function pad2(value) {
    return value < 10 ? "0" + value : "" + value;
}

/** "MM/DD/YYYY" -> "YYYY-MM-DD" */
function toISO(date) {
    if (!date || date.length < 10) {
        return null;
    }
    return date.substring(6, 10) + "-" + date.substring(0, 2) + "-" + date.substring(3, 5);
}

export default function PatientDebitInfoReport() {
    const todaysdate = new Date();
    const startdate = new Date(new Date().setDate(todaysdate.getDate() - 30));
    const enddate = new Date(new Date().setDate(todaysdate.getDate() + 1));

    const defaultFrom = pad2(startdate.getMonth() + 1) + "/" + pad2(startdate.getDate()) + "/" + startdate.getFullYear();
    const defaultTo = pad2(enddate.getMonth() + 1) + "/" + pad2(enddate.getDate()) + "/" + enddate.getFullYear();

    const [range, setRange] = useState({ fromdate: toISO(defaultFrom), todate: toISO(defaultTo) });

    // The picked (MM/DD/YYYY) endpoints; the first click picks "from", the second "to".
    const picked = useRef({ from: "", to: "" });

    useEffect(() => {
        const input = $("#debit_updated_range");

        if (input.hasClass("hasDatepicker")) {
            return;
        }

        input.datepicker({
            ...DATEPICKER_OPTIONS,
            onSelect: function (dateText) {
                if (!picked.current.from || picked.current.to) {
                    // Start a new range and immediately reopen for the "to" date.
                    picked.current = { from: dateText, to: "" };
                    input.val(dateText + " - ");
                    setTimeout(() => input.datepicker("show"), 0);
                    return;
                }

                let from = picked.current.from;
                let to = dateText;
                if (new Date(to) < new Date(from)) {
                    [from, to] = [to, from];
                }
                picked.current = { from, to };
                input.val(from + " - " + to);
                // No Search button: apply as soon as the range is complete.
                setRange({ fromdate: toISO(from), todate: toISO(to) });
            },
        });
    }, []);


    return (
        <div className="container" id="content" style={{ fontSize: "1em" }}>
            <div id="container">
                <div className="containerRight">
                    <h1 style={{ fontSize: "1.5em", lineHeight: "1.49em" }}>Patients with an Updated Virtual Debit Number</h1>
                    <div id="date_wrapper">
                        <div className="required"></div>
                        <br />
                        <form
                            onSubmit={(e) => e.preventDefault()}
                            acceptCharset="utf-8"
                            className="find_patient"
                            style={{ display: "flex", alignItems: "stretch", gap: "10px" }}
                        >
                            <div
                                style={{
                                    position: "relative",
                                    display: "flex",
                                    alignItems: "center",
                                    width: "320px",
                                    border: "1px solid #ccc",
                                    borderRadius: "4px",
                                    background: "#fff",
                                    padding: "6px 10px",
                                }}
                            >
                                <label
                                    htmlFor="debit_updated_range"
                                    style={{
                                        position: "absolute",
                                        top: "-0.65em",
                                        left: "6px",
                                        // the global "label" rule is width: 45%; float: left; text-align: right
                                        display: "inline-block",
                                        width: "auto",
                                        float: "none",
                                        textAlign: "left",
                                        margin: 0,
                                        padding: "0 4px",
                                        background: "#fff",
                                        fontSize: "0.8em",
                                        lineHeight: "1",
                                        color: "#666",
                                    }}
                                >
                                    Date
                                </label>
                                <input
                                    className="datepicker"
                                    name="debit_updated_range"
                                    type="text"
                                    size="26"
                                    placeholder={defaultFrom + " - " + defaultTo}
                                    id="debit_updated_range"
                                    autoComplete="off"
                                    style={{
                                        // the global ".find_patient input[type=text]" rule is width: 22%; float: left; margin-right: 20px
                                        flex: "1 1 auto",
                                        width: "100%",
                                        minWidth: 0,
                                        boxSizing: "border-box",
                                        float: "none",
                                        border: "none",
                                        outline: "none",
                                        boxShadow: "none",
                                        // Only the colour: main.css `input.datepicker` supplies the
                                        // calendar background-image (data-icon.png, right aligned).
                                        backgroundColor: "transparent",
                                        margin: 0,
                                        // Keep typed text clear of the 27px background icon.
                                        padding: "0 32px 0 0",
                                        height: "auto",
                                        cursor: "pointer",
                                    }}
                                />
                            </div>
                        </form>
                        <br />
                    </div>
                    <PatientDebitStatus fromdate={range.fromdate} todate={range.todate} />
                </div>
            </div>
        </div>
    );
}


